import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_34444_24506)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.8249 10.2374H20.1V10.2H12V13.8H17.0864C16.3443 15.8956 14.3504 17.4 12 17.4C9.01785 17.4 6.6 14.9822 6.6 12C6.6 9.01785 9.01785 6.6 12 6.6C13.3765 6.6 14.6289 7.1193 15.5825 7.96755L18.1281 5.4219C16.5207 3.92385 14.3706 3 12 3C7.02975 3 3 7.02975 3 12C3 16.9703 7.02975 21 12 21C16.9703 21 21 16.9703 21 12C21 11.3966 20.9379 10.8075 20.8249 10.2374Z",
				fill: "#FFC107"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.03773 7.81095L6.99468 9.9795C7.79478 7.9986 9.73245 6.6 12 6.6C13.3765 6.6 14.6289 7.1193 15.5825 7.96755L18.1281 5.4219C16.5207 3.92385 14.3706 3 12 3C8.5431 3 5.54523 4.95165 4.03773 7.81095Z",
				fill: "#FF3D00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 21C14.3247 21 16.437 20.1104 18.034 18.6636L15.2485 16.3065C14.3146 17.0168 13.1734 17.4009 12 17.4C9.6591 17.4 7.67142 15.9074 6.92262 13.8243L3.98772 16.0856C5.47722 19.0002 8.50215 21 12 21Z",
				fill: "#4CAF50"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.8249 10.2374H20.1V10.2H12V13.8H17.0864C16.7314 14.7974 16.0933 15.6685 15.2485 16.3065L18.034 18.6636C17.8369 18.8427 21 16.5 21 12C21 11.3966 20.9379 10.8075 20.8249 10.2374Z",
				fill: "#1976D2"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_34444_24506",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
			fill: "white"
		})
	}) })]
});
export default SvgGoogleIcon;
